// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"41a2d10f","936":"87bcda6a"}[chunkId] + ".chunk.js";
};